import { rem } from '@innovyze/stylovyze';
import styled from 'styled-components';

export const UpsertLiftStationsFormContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-gap: ${rem(24)};
`;

export const MapWrapper = styled.div`
	height: ${rem(500)};
	/* padding: ${rem(16)} 0; */
`;

export const MapContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	justify-content: center;
	align-items: center;
	height: ${rem(530)};
`;
